import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from './utils/store';

// const BEE_LOGO_URL = 'https://lh3.googleusercontent.com/aida/ADBb0uh5YIUQIcPyGFsYE7RjHh_WV2IM8xd8912P1XHiFTeTiegsMvAyLUBt5zro-tuwD7z8Vt-7H6w-EP-eV2jJRKJDddhrQQCvCHAMQ7u9jC9g0SNGTrH1d-rp584H_UVXSPJp4Gzzk9lRk21kyD8KO0_R2fM3gmM2So41Er3Ll6KD_CUMH5i4dz29-ZtWK-1I5wF3pMtMEE2qe3ANlpu4f9OYH-kqW1TVVE5CnocKAJxIkbBc_X-D8EgO6XpNc-j0hKL0fi_C1hmu';

// Animated bee splash shown during redux-persist rehydration (prevents blank white screen)
const AppLoader = () => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff",
      zIndex: 9999,
      overflow: "hidden",
    }}>
    <style>{`
      @keyframes enterFromBottom {
        0%   { transform: translateY(100vh); opacity: 0; }
        100% { transform: translateY(0);     opacity: 1; }
      }
      @keyframes beehover {
        0%, 100% { transform: translateY(0);    }
        50%       { transform: translateY(-20px); }
      }
      @keyframes wingBeat {
        0%, 100% { transform: rotateY(0deg);  }
        50%       { transform: rotateY(45deg); }
      }
      @keyframes wingBeatLeft {
        0%, 100% { transform: rotateY(0deg);   }
        50%       { transform: rotateY(-45deg); }
      }
      .bee-entrance { animation: enterFromBottom 1.5s cubic-bezier(0.22, 1, 0.36, 1) forwards; }
      .bee-hover    { animation: beehover 3s ease-in-out infinite; animation-delay: 1.5s; animation-fill-mode: both; }
      .bee-left-wing  { animation: wingBeatLeft 1.5s ease-in-out infinite; animation-delay: 1.5s; }
      .bee-right-wing { animation: wingBeat     1.5s ease-in-out infinite; animation-delay: 1.5s; }
    `}</style>
    <div className="bee-entrance">
      <div
        className="bee-hover"
        style={{
          position: "relative",
          width: 150,
          height: 150,
          perspective: 1000,
        }}>
        {[
          {
            cls: "bee-left-wing",
            extra: {
              clipPath: "polygon(0% 0%, 35% 0%, 35% 100%, 0% 100%)",
              transformOrigin: "35% center",
            },
          },
          {
            cls: "",
            extra: {
              clipPath: "polygon(35% 0%, 65% 0%, 65% 100%, 35% 100%)",
              zIndex: 2,
            },
          },
          {
            cls: "bee-right-wing",
            extra: {
              clipPath: "polygon(65% 0%, 100% 0%, 100% 100%, 65% 100%)",
              transformOrigin: "65% center",
            },
          },
        ].map(({ cls, extra }, i) => (
          <div
            key={i}
            className={cls}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url('/logo.png')`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              ...extra,
            }}
          />
        ))}
      </div>
    </div>
  </div>
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store.store}>
      <PersistGate loading={<AppLoader />} persistor={store.persistor}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered: ', registration);
        // When a new SW takes control, reload to ensure fresh JS bundle is used.
        // Guard flag prevents infinite reload loop (e.g. in dev or rapid SW cycles).
        let reloading = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloading) return;
          reloading = true;
          window.location.reload();
        });
      })
      .catch((error) => {
        console.error('Service Worker registration failed: ', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
